import { Box, LinearProgress, Typography, styled } from '@mui/material';
import { theme } from '~/shared/styles/theme';

interface ProgressBarProps {
  percentage: number;
  showLabel?: boolean;
}

export const ProgressBar = ({
  percentage,
  showLabel = true,
}: ProgressBarProps) => {
  return (
    <Container>
      <ProgressBarContainer>
        <StyledLinearProgress
          variant="determinate"
          value={percentage}
          data-testid="progress-bar"
        />
      </ProgressBarContainer>
      {showLabel && (
        <Label data-testid="progress-label">{Math.round(percentage)}%</Label>
      )}
    </Container>
  );
};

const Container = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr auto 1fr',
  alignItems: 'center',
  position: 'relative',
});

const ProgressBarContainer = styled(Box)({
  height: 17,
  width: '190px',
  borderRadius: '100px',
  overflow: 'hidden',
  gridColumn: '2',
});

const StyledLinearProgress = styled(LinearProgress)({
  height: '100%',
  backgroundColor: theme.palette.common.white,
  '& .MuiLinearProgress-bar': {
    backgroundColor: theme.palette.custom.limeGreen,
  },
});

const Label = styled(Typography)({
  color: theme.palette.custom.darkBrown,
  fontSize: '12px',
  fontWeight: 500,
  textAlign: 'right',
  position: 'absolute',
  left: '50%',
  marginLeft: `calc(95px + ${theme.spacing(2)})`,
  whiteSpace: 'nowrap',
  top: '50%',
  transform: 'translateY(-50%)',
});
